import React, {Component} from 'react';
import PropTypes from 'prop-types';

import PriceLocalised from '../PriceLocalised/PriceLocalised';
import {FormattedMessage} from "react-intl";

export default class ButtonWithPrice extends Component {
    renderPrice() {
        if (!this.props.price || this.props.price === 0) return <span>&nbsp;<FormattedMessage defaultMessage="zdarma" id={"global.free"}/></span>

        return (
            <span className="btn-price-separator">
                <PriceLocalised value={this.props.price} />
            </span>
        );
    }
    render() {
        return (
            <button className="btn btn-sm btn-primary btn-price" onClick={this.props.onButtonClick}>
                <span className="btn-price-label">{this.props.label}</span>
                {this.renderPrice()}
            </button>
        );
    }
}

ButtonWithPrice.propTypes = {
    label: PropTypes.node,
    onButtonClick: PropTypes.func,
    price: PropTypes.number
};
